(() => {
  if (window.productReviewsAnchorInitialized) return;

  window.productReviewsAnchorInitialized = true;

  const targetSelectors = [
    '#product-reviews',
    'reviewsio-card-carousel',
    '[id^="reviewsio-carousel-widget-"]',
    '.PolarisWidget-prefix',
    '#shopify-product-reviews'
  ];

  document.addEventListener('click', (event) => {
    const link = event.target.closest('.ds-product__reviews-rating-link');

    if (!link) return;

    const target = document.querySelector(targetSelectors.join(','));

    if (!target) return;

    event.preventDefault();

    let anchor = document.getElementById('product-reviews');

    if (!anchor) {
      anchor = document.createElement('span');
      anchor.id = 'product-reviews';
      anchor.className = 'anchor';
      target.before(anchor);
    }

    anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });

    if (window.location.hash !== '#product-reviews') {
      window.history.pushState(null, '', '#product-reviews');
    }
  });
})();
